import * as React from "react"
import { Box, Chip, IconButton, Modal, Typography } from "@mui/material"
import { ImageSeeker, IconSeeker } from "@ui-seeker/core"

import { imageComparisonModal } from "./@signals"


function ImageContainer({ url, label, labelColor = 'default' }) {
    return (
        <Box
            sx={{
                flex: 1,
                minWidth: 0,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                p: 1,
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                overflow: 'hidden',
                bgcolor: 'background.default',
                position: 'relative'
            }}
        >
            <Box position="absolute" top={8} left={8} zIndex={1}>
                {!!label && <Chip size="small" label={label} color={labelColor} sx={{ height: 22 }} />}
            </Box>

            <Box sx={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                '&:hover .zoomable': {
                    transform: 'scale(1.5)',
                }
            }}>
                {url ? (
                    <ImageSeeker
                        useSpinner
                        lazyLoad={false}
                        src={url}
                        sx={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                            transition: 'transform .2s ease',
                            willChange: 'transform',
                            cursor: 'zoom-in',
                        }}
                        className="zoomable"
                    />
                ) : (
                    <Box sx={{ color: '#9ca3af', textAlign: 'center' }}>
                        <IconSeeker icon="image" sx={{ fontSize: 48, mb: 1 }} />
                        <Typography variant="body2">No image</Typography>
                    </Box>
                )}
            </Box>
        </Box>
    )
}


export default function ImageComparisonModal() {
    const data = imageComparisonModal.value
    const isOpen = data !== null

    const handleClose = () => {
        imageComparisonModal.value = null
    }

    return (
        <Modal
            open={isOpen}
            onClose={handleClose}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 2
            }}
        >
            <Box
                sx={{
                    width: '90vw',
                    maxWidth: 1200,
                    height: '80vh',
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 24,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden'
                }}
            >
                {/* Header */}
                <Box sx={{
                    p: 2,
                    borderBottom: '1px solid #e5e7eb',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        Image Comparison
                    </Typography>
                    <IconButton onClick={handleClose}>
                        <IconSeeker icon="xmark" />
                    </IconButton>
                </Box>

                {/* Product info */}
                {(data?.title || data?.skuName) && (
                    <Box sx={{
                        px: 2,
                        py: 1,
                        backgroundColor: '#f9fafb',
                        borderBottom: '1px solid #e5e7eb',
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 2
                    }}>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography variant="body2" sx={{ fontWeight: 500 }} noWrap>
                                {data?.title || '-'}
                            </Typography>
                            {data?.variantRaw && (
                                <Chip
                                    label={data.variantRaw}
                                    size="small"
                                    sx={{
                                        mt: 0.5,
                                        fontSize: '0.75rem',
                                        height: 22,
                                        fontWeight: 600,
                                        backgroundColor: '#e0e7ff',
                                        color: '#4338ca'
                                    }}
                                />
                            )}
                        </Box>
                        {data?.skuName && (
                            <Typography variant="body2" sx={{ fontWeight: 500, flex: 1, textAlign: 'right', color: '#059669' }} noWrap>
                                {data.skuName}
                            </Typography>
                        )}
                    </Box>
                )}

                {/* Images */}
                <Box sx={{
                    flex: 1,
                    p: 2,
                    display: 'flex',
                    gap: 2,
                    overflow: 'hidden'
                }}>
                    <ImageContainer
                        url={data?.rawImage}
                        label="Raw Product"
                        labelColor="warning"
                    />
                    <ImageContainer
                        url={data?.skuImage}
                        label="SKU"
                        labelColor="success"
                    />
                </Box>
            </Box>
        </Modal>
    )
}
